/* eslint-disable max-len */
import * as React from 'react';
import { useEffect } from 'react';
import { runInAction } from 'mobx';
import { Navigate, Route, Routes } from 'react-router-dom';
import Auth from './Components/Auth/Auth';
import AdminPage from './Pages/Admin/AdminPage';
import TrappedCommunicationsPage from './Pages/Admin/TrappedCommunicationsPage';
import Topbar from './Components/Topbar/Topbar';
import { store } from 'Models/Store';
import { ADMIN_PAGE_TITLE } from 'ConstantPageNames';
import { observer } from 'mobx-react';

const AdminSwitch = observer(() => {
	return (
		<>
			<div className="body-content">
				<Routes />
			</div>
		</>
	);
});

const Admin = observer(() => {
	useEffect(() => {
		runInAction(() => {
			// The admin backend shares the frontend design system — there's no separate `.admin` styling.
			store.appLocation = 'frontend';
		});
		document.title = ADMIN_PAGE_TITLE;
	}, []);

	if (!store.userGroups.some(ug => ug.hasBackendAccess)) {
		return <Navigate to="/404" replace />;
	}

	return (
		<>
			<div className="body-container">
				<Topbar currentLocation="admin" />
				<Routes>
					<Route
						path="/*"
						element={
							<div className="frontend">
								<div className="body-content">
									<Auth>
										<Routes>
											<Route
												path="/trapped-communications/*"
												element={<TrappedCommunicationsPage />}
											/>
											<Route path="/*" element={<AdminPage />} />
										</Routes>
									</Auth>
								</div>
							</div>
						}
					/>
				</Routes>
			</div>
		</>
	);
});

export default Admin;
